import React, {Component} from 'react';
import Header from "../header";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import Footer from "../footer";
import Tual from "./small/tual";
import { ALL_EBADS, albumEbads } from '../constants/album-ebads';
import PhotoBlock from "./small/photoBlock";
import Printing from "./small/printing";
import loader from './../assets/img/Eclipse.gif';
import Snackbar from 'material-ui/Snackbar';
import { Link } from 'react-router-dom';
import DatePicker from 'material-ui/DatePicker';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';

const styles = {
  successColor: {
    color: "#1a1a1a",
  },
  errorColor: {
    color: "#F44336"
  },
};

class Order extends Component {

  constructor(props) {
    super(props);

    this.contentScrollRef = React.createRef();

    this.state = {
      formStep: 1,
      value: 1,
      orderType: "",
      order_id: null,
      submitClicked: false,
      backButtonError: true,
      orderGiven: false,

      // Albüm Tipi
      albumValue: null,
      albumError: true,
      albumRightValue: "",

      // Sayfa Sayısı
      checkPageNumber: false,
      pageNumber: 1,
      pageNumberError: false,

      // Kapak Modeli
      coverModelValue: null,
      coverModelError: true,
      coverRightModelValue: "",
      selectedCoverKey: null,
      isCustomEbat: false,
      coverPreviewOpen: false,
      coverPreviewIndex: 0,


      // Albüm Ebatı
      albumEbatValue: null,
      albumEbatError: true,
      albumRightEbatValue: "",

      // panoramik sayısı
      panoramikLength: 0,

      // Albüm Sıralama - Checkbox
      albumRankingValue: "Sıralı",

      // Aile Albümü
      albumFamilyValue: 0,
      checkFamilyAlbum: false,
      familyAlbumVal: 0,
      familyAlbumError: false,


      // Hediye Foto
      albumGiftPhotoValue: "",
      checkAlbumGiftPhotoValue: false,
      albumGiftPhotoError: false,

      // Hediye Tual
      albumGiftTualValue: "",
      albumGiftTualError: false,

      // Hediye Foto 2
      albumGiftPhotoValue2: "",
      checkAlbumGiftPhotoValue2: false,
      albumGiftPhotoError2: false,

      // Hediye Tual 2
      albumGiftTualValue2: "",
      albumGiftTualError2: false,

      // Hediye Foto 3
      albumGiftPhotoValue3: "",
      checkAlbumGiftPhotoValue3: false,
      albumGiftPhotoError3: false,

      // Hediye Tual 3
      albumGiftTualValue3: "",
      albumGiftTualError3: false,

      // Açıklama
      albumDescription: "",

      // Submit
      isSubmit: false,

      // panoramik-album-ebat
      panoramikAlbumEbat: null,
      panoramikAlbumEbat2: null,
      panoramikAlbumEbat3: null,
      brideName: '',
      fulldate: null,

      // School

      schoolAlbumEbatValue: null,
      schoolAlbumEbatRightValue: null,

      // Sayfa sayısı
      schoolAlbumFamilyValue: 0,
      schoolCheckFamilyAlbum: false,
      schoolFamilyAlbumVal: 0,
      schoolFamilyAlbumError: false,

      // Okul - normal girdiler
      schoolStudentNumber: 0,
      schoolStudentNumber2: 0,
      schoolDescription: "",

      // Okul - Takvim Ebatı

      schoolCalendarDimensionValue: null,
      schoolCalendarDimensionNumber: 0,


      // Photo Close
      isPhotoShow: false,

      // Özel Albüm ebatı
      specialAlbumValue: null,


      // TUAL

      tualArray: [],
      tualObj: {},
      tualDesc: "",

      // FotoBlok

      photoBlockArray: [],
      photoBlockObj: {},
      photoBlockDesc: "",

      // Printing

      printingArray: [],
      printingObj: {},
      printingDesc: "",

      // Snackbar
      open: false,
      submitMessage: "",
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.formStep !== this.state.formStep) {
      this.resetContentScroll();
    }
  }

  resetContentScroll() {
    const active = document.activeElement;
    if (active && active !== document.body && typeof active.blur === 'function') {
      active.blur();
    }

    const scrollToTop = () => {
      const el = this.contentScrollRef.current;
      document.documentElement.style.overflowAnchor = 'none';
      document.body.style.overflowAnchor = 'none';

      let node = el;

      while (node) {
        node.style.overflowAnchor = 'none';
        if (typeof node.scrollTo === 'function') {
          node.scrollTo(0, 0);
        }
        node.scrollTop = 0;
        node = node.parentElement;
      }

      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    scrollToTop();
    window.requestAnimationFrame(() => {
      scrollToTop();
      window.requestAnimationFrame(scrollToTop);
    });
    window.setTimeout(scrollToTop, 0);
    window.setTimeout(scrollToTop, 60);
  }

  snackbarClose = () => {
    this.setState({
      open: false,
    });
  };

  getSelectedEbatForCovers() {
    if (this.state.albumEbatValue === 'custom') {
      return this.state.specialAlbumValue || null;
    }
    return this.state.albumEbatValue;
  }

  getAvailableAlbums(ebat) {
    if (!ebat) {
      return [];
    }

    const normalizedEbat = ebat.trim();

    return Object.entries(albumEbads).filter(([, album]) => {
      if (this.state.isCustomEbat) {
        return album.all === true || album.ebads.includes(normalizedEbat);
      }

      return album.ebads.includes(normalizedEbat);
    });
  }

  shouldShowCoverSelection() {
    if (this.state.albumEbatValue === 'custom') {
      return !!this.state.specialAlbumValue;
    }

    return !!this.state.albumEbatValue;
  }

  goToFormStep(step) {
    this.setState({ formStep: step });
  }

  canProceedFromPanoramicStep2() {
    const hasEbat = this.state.albumEbatValue === 'custom'
      ? !!this.state.specialAlbumValue
      : !!this.state.albumEbatValue;

    if (!hasEbat || !this.state.selectedCoverKey) {
      return false;
    }

    const selectedEbat = this.getSelectedEbatForCovers();
    const availableAlbums = this.getAvailableAlbums(selectedEbat);

    return availableAlbums.some(([key]) => key === this.state.selectedCoverKey);
  }

  handleFormNext() {
    if (this.state.formStep === 1 && this.state.value > 1) {
      this.setState({ formStep: 2 });
    } else if (this.state.formStep === 2 && this.state.value === 2 && this.canProceedFromPanoramicStep2()) {
      this.setState({ formStep: 3 });
    }
  }

  handleFormBack() {
    if (this.state.value === 2 && this.state.formStep === 3) {
      this.setState({ formStep: 2 });
      return;
    }

    this.setState({ formStep: 1 });
  }

  canGoBackInForm() {
    return this.state.formStep > 1 && !this.state.isSubmit;
  }

  handleSidebarBack() {
    if (this.state.isSubmit) {
      this.backOrder();
      return;
    }

    this.handleFormBack();
  }

  isLastFormStep() {
    if (this.state.value === 1 || this.state.formStep === 1) {
      return false;
    }

    if (this.state.value === 2) {
      return this.state.formStep === 3;
    }

    return this.state.formStep === 2;
  }

  canProceedToNextStep() {
    if (this.state.value === 1) {
      return false;
    }

    if (this.state.formStep === 1) {
      return true;
    }

    if (this.state.value === 2 && this.state.formStep === 2) {
      return this.canProceedFromPanoramicStep2();
    }

    return false;
  }

  handlePrimaryAction(e) {
    if (this.isLastFormStep()) {
      this.orderSubmit(e);
      return;
    }

    this.handleFormNext();
  }

  getSelectedCoverAlbum() {
    if (!this.state.selectedCoverKey) {
      return null;
    }

    return albumEbads[this.state.selectedCoverKey] || null;
  }

  renderPanoramicSelectionSummary() {
    const selectedCoverAlbum = this.getSelectedCoverAlbum();

    return (
      <div className="order-selection-summary">
        {selectedCoverAlbum && (
          <div className="order-selection-summary-cover">
            <img src={selectedCoverAlbum.image} alt={selectedCoverAlbum.name}/>
          </div>
        )}

        <div className="order-selection-summary-details">
          <div className="order-selection-summary-item">
            <span className="summary-label">Sipariş Türü</span>
            <span className="summary-value">{this.state.orderType}</span>
          </div>
          <div className="order-selection-summary-item">
            <span className="summary-label">Albüm Ebatı</span>
            <span className="summary-value">{this.state.albumRightEbatValue}</span>
          </div>
          <div className="order-selection-summary-item">
            <span className="summary-label">Kapak Modeli</span>
            <span className="summary-value">{this.state.coverRightModelValue}</span>
          </div>
        </div>
      </div>
    );
  }

  renderContentContinueButton() {
    if (this.isLastFormStep() || this.state.isSubmit) {
      return null;
    }

    return (
      <div className="form-group form-step-actions content-continue-actions">
        <RaisedButton
          label="Devam"
          backgroundColor="#2c3e50"
          labelColor="#fff"
          type="button"
          onClick={this.handleFormNext.bind(this)}
          disabled={!this.canProceedToNextStep()}
        />
      </div>
    );
  }

  resetPanoramicSelections() {
    return {
      albumEbatValue: null,
      albumRightEbatValue: '',
      albumEbatError: true,
      isCustomEbat: false,
      specialAlbumValue: null,
      coverModelValue: null,
      coverRightModelValue: '',
      coverModelError: true,
      selectedCoverKey: null,
      isPhotoShow: false,
      coverPreviewOpen: false,
      coverPreviewIndex: 0,
    };
  }

  openCoverPreview(index) {
    this.setState({
      coverPreviewOpen: true,
      coverPreviewIndex: index,
    });
  }

  selectCoverFromPreview() {
    const albums = this.getAvailableAlbums(this.getSelectedEbatForCovers());
    const currentAlbum = albums[this.state.coverPreviewIndex];

    if (!currentAlbum) {
      return;
    }

    const [key, album] = currentAlbum;
    this.coverAlbumSelect(key, album.name);
    this.closeCoverPreview();
  }

  closeCoverPreview() {
    this.setState({
      coverPreviewOpen: false,
    });
  }

  moveCoverPreview(step) {
    const albums = this.getAvailableAlbums(this.getSelectedEbatForCovers());
    if (!albums.length) {
      return;
    }

    this.setState({
      coverPreviewIndex: (this.state.coverPreviewIndex + step + albums.length) % albums.length,
    });
  }

  handleChange(event, index, value) {
    this.setState({
      value: value,
      orderType: event.target.innerText,
      formStep: 1,
      ...this.resetPanoramicSelections(),
    });
  }

  albumValueChange(event, index, value) {
    this.setState({
      albumValue: value,
      albumRightValue: event.target.innerText,
      albumError: false,
    })
  }

  coverAlbumSelect(key, name) {
    this.setState({
      selectedCoverKey: key,
      coverModelValue: key,
      coverRightModelValue: name,
      coverModelError: false,
    });
  }

  albumEbatChipClick(ebat) {
    if (ebat === 'custom') {
      this.setState({
        albumEbatValue: 'custom',
        albumRightEbatValue: '',
        isCustomEbat: true,
        albumEbatError: false,
        specialAlbumValue: null,
        coverModelValue: null,
        coverRightModelValue: '',
        coverModelError: true,
        selectedCoverKey: null,
        coverPreviewOpen: false,
        coverPreviewIndex: 0,
      });
      return;
    }

    this.setState({
      albumEbatValue: ebat,
      albumRightEbatValue: ebat,
      isCustomEbat: false,
      albumEbatError: false,
      specialAlbumValue: null,
      coverModelValue: null,
      coverRightModelValue: '',
      coverModelError: true,
      selectedCoverKey: null,
      coverPreviewOpen: false,
      coverPreviewIndex: 0,
    });
  }

  coverValueChange(event, index, value) {
    this.setState({
      coverModelValue: value,
      coverRightModelValue: event.target.innerText,
      coverModelError: false,
    });
  }

  albumEbatChange(event, index, value) {
    this.setState({
      albumEbatValue: value,
      albumRightEbatValue: event.target.innerText,
      albumEbatError: false,
      coverRightModelValue: '',
      coverModelValue: null,
      selectedCoverKey: null,
    });
  }

  pageNumberChange(e) {

    if (e.target.value.length > 0 && e.target.value >= 0 && e.target.value <= 25) {
      this.setState({
        pageNumberError: false,
      })
    } else {
      this.setState({
        pageNumberError: true,
      })
    }

    this.setState({
      pageNumber: e.target.value,
      checkPageNumber: true
    })
  }

  familyAlbumChange(e) {

    if (e.target.value.length > 0 && e.target.value >= 0 && e.target.value <= 25) {
      this.setState({
        familyAlbumError: false,
      })
    } else {
      this.setState({
        familyAlbumError: true,
      })
    }

    this.setState({
      familyAlbumVal: e.target.value,
      checkFamilyAlbum: true
    })
  }

  giftPhotoChange(e) {

    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftPhotoValue: newValue,
      checkAlbumGiftPhotoValue: true,
    })
  }

  giftTualChange(e) {
    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftTualValue: newValue,
    })
  }

  giftPhotoChange2(e) {

    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftPhotoValue2: newValue,
      checkAlbumGiftPhotoValue2: true,
    })
  }

  giftTualChange2(e) {
    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftTualValue2: newValue,
    })
  }

  giftPhotoChange3(e) {

    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftPhotoValue3: newValue,
      checkAlbumGiftPhotoValue3: true,
    })
  }

  giftTualChange3(e) {
    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftTualValue3: newValue,
    })
  }

  albumRankingChange(e) {

    if (parseInt(e.target.value, 10) === 1) {
      this.setState({
        albumRankingValue: "Sıralı",
      })
    } else {
      this.setState({
        albumRankingValue: "Sırasız",
      })
    }
  }

  descChange(e) {
    this.setState({
      albumDescription: e.target.value,
    })
  }

  orderSubmit(e) {
    e.preventDefault();

    let orderid = null;
    let companyName = localStorage.getItem("companyName");

    this.setState({
      submitClicked: true,
    });

    fetch("https://saydamalbum.com/saydamWebservice/getLastOrder.php", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }).then((response) => {
      return response.json();
    }).then((data) => {
      let isDataFull = false;

      if (data.data === "null") {
        orderid = 0;
        isDataFull = true;
      } else {
        orderid = data.data["o_orderID"];
      }

      this.setState({
        order_id: orderid
      });

      if (data.responseType === 200 || isDataFull) {
        if (this.state.value === 2) { // Album

          let familyAlbumEbatValue = null;
          if (this.state.albumEbatValue === '30x70') {
            familyAlbumEbatValue = this.state.panoramikAlbumEbatText;
          } else if (this.state.albumEbatValue === '30x80') {
            familyAlbumEbatValue = this.state.panoramikAlbumEbat2Text;
          } else if (this.state.albumEbatValue === '30x50') {
            familyAlbumEbatValue = "15x25";
          } else if (this.state.albumEbatValue === '30x60') {
            familyAlbumEbatValue = "15x30";
          } else if (this.state.albumEbatValue === '25x50') {
            familyAlbumEbatValue = "25x50";
          }

          let body = (
            "orderType=" + this.state.value
            + "&orderID=" + (parseInt(orderid, 10) + parseInt(1, 10))
            + "&orderName=" + this.state.orderType
            + "&albumEbat=" + this.state.albumRightEbatValue
            + "&albumNumber=" + this.state.panoramikLength
            + "&familyAlbumEbat=" + familyAlbumEbatValue
            + "&familyAlbumNumber=" + this.state.familyAlbumVal
            + "&albumType=" + this.state.albumRightValue
            + "&pageNumber=" + this.state.pageNumber
            + "&coverModel=" + this.state.coverRightModelValue
            + "&albumOrder=" + this.state.albumRankingValue
            + "&printingEbat=" + this.state.albumGiftPhotoValue
            + "&tualEbat=" + this.state.albumGiftTualValue
            + "&printingEbat2=" + this.state.albumGiftPhotoValue2
            + "&tualEbat2=" + this.state.albumGiftTualValue2
            + "&printingEbat3=" + this.state.albumGiftPhotoValue3
            + "&tualEbat3=" + this.state.albumGiftTualValue3
            + "&companyName=" + localStorage.getItem("companyName")
            + "&companyMail=" + localStorage.getItem("companyMail")
          );

          console.log('BEFORE:', body);

          if (this.state.brideName) {
            body += "&brideName=" + encodeURIComponent(this.state.brideName);
          } else {
            body += "&brideName=''"; 
          }

          if (this.state.albumDescription) {
            body += "&description=" + encodeURIComponent(this.state.albumDescription);
          } else {
            body += "&description=''";
          }

          if (this.state.fulldate) {
            body += "&eventDate=" + this.state.fulldate;
          } else {
            body += "&eventDate=''";
          }

          console.log(body, this.state);

          fetch("https://saydamalbum.com/saydamWebservice/giveorder.php", {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: body
          }).then((response) => {
            return response.json();
          }).then((data) => {
            this.setState({
              open: true,
              submitMessage: data.responseMessage,
              submitClicked: false,
            });

            if (data.responseType === 200) {
              this.setState({
                isSubmit: true,
                orderGiven: true,
                backButtonError: false,
              });
            }
          });
        }
        else if (this.state.value === 3) { // Okul

          let studentNumber = 0;
          if (!(this.state.schoolAlbumEbatValue === 8 || this.state.schoolAlbumEbatValue === 9 || this.state.schoolAlbumEbatValue === 10)) {
            studentNumber = this.state.schoolStudentNumber;
          } else {
            studentNumber = this.state.schoolStudentNumber2;
          }

          let body2 = (
            "orderType=" + this.state.value
            + "&orderID=" + (parseInt(orderid, 10) + parseInt(1, 10))
            + "&orderName=" + this.state.orderType
            + "&albumEbat=" + this.state.schoolAlbumEbatRightValue
            + "&pageNumber=" + this.state.schoolFamilyAlbumVal
            + "&studentNumber=" + studentNumber
            + "&calendarEbat=" + this.state.schoolCalendarDimensionValue
            + "&calendarNumber=" + this.state.schoolCalendarDimensionNumber
            + "&companyName=" + localStorage.getItem("companyName")
            + "&companyMail=" + localStorage.getItem("companyMail")
          );

          if (this.state.schoolDescription) {
            body2 += "&description=" + encodeURIComponent(this.state.schoolDescription);
          } else {
            body2 += "&description=''";
          }

          fetch("https://saydamalbum.com/saydamWebservice/giveorder.php", {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: body2
          }).then((response) => {
            return response.json();
          }).then((data) => {

              this.setState({
                open: true,
                submitMessage: data.responseMessage,
                submitClicked: false,
              });

              if (data.responseType === 200) {
                this.setState({
                  isSubmit: true,
                  orderGiven: true,
                  backButtonError: false,

                });
              }
            }
          );

        }
        else if (this.state.value === 4) { // Tual
          if (Object.keys(this.state.tualObj).length === 0) {
            this.setState({
              open: true,
              submitMessage: "LÜTFEN EKLE BUTONUNA BASTIĞINIZDAN EMİN OLUNUZ.",
              submitClicked: false,
            })
          } else {
            for (let item in  Object.keys(this.state.tualObj)) {
              let ebat = this.state.tualObj[item].ebatValue;
              let number = this.state.tualObj[item].tualNumber;

              let body = (
                "orderType=" + this.state.value
                + "&orderID=" + (parseInt(orderid, 10) + parseInt(1, 10) + parseInt(item, 10))
                + "&orderName=" + this.state.orderType
                + "&companyName=" + localStorage.getItem("companyName")
                + "&companyMail=" + localStorage.getItem("companyMail")
                + "&ebat=" + ebat
                + "&number=" + number
              );

              if (this.state.tualDesc) {
                body += "&description=" + encodeURIComponent(this.state.tualDesc);
              } else {
                body += "&description=''";
              }

              fetch("https://saydamalbum.com/saydamWebservice/giveorder.php", {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: body
              }).then((response) => {
                return response.json();
              }).then((data) => {
                this.setState({
                  open: true,
                  submitMessage: data.responseMessage,
                  submitClicked: false,
                });

                if (data.responseType === 200) {
                  this.setState({
                    isSubmit: true,
                    orderGiven: true,
                    backButtonError: false,
                  });
                }
              });
            }
          }
        }
        else if (this.state.value === 5) { // Fotoblok
          if (Object.keys(this.state.photoBlockObj).length === 0) {
            this.setState({
              open: true,
              submitMessage: "LÜTFEN EKLE BUTONUNA BASTIĞINIZDAN EMİN OLUNUZ.",
              submitClicked: false,
            })
          } else {
            for (let item in  Object.keys(this.state.photoBlockObj)) {
              let ebat = this.state.photoBlockObj[item].ebatValue;
              let number = this.state.photoBlockObj[item].photoBlockNumber;

              let body = (
                "orderType=" + this.state.value
                + "&orderID=" + (parseInt(orderid, 10) + parseInt(1, 10) + parseInt(item, 10))
                + "&orderName=" + this.state.orderType
                + "&companyName=" + localStorage.getItem("companyName")
                + "&companyMail=" + localStorage.getItem("companyMail")
                + "&ebat=" + ebat
                + "&number=" + number
              );

              if (this.state.photoBlockDesc) {
                body += "&description=" + encodeURIComponent(this.state.photoBlockDesc);
              } else {
                body += "&description=''";
              }
              

              fetch("https://saydamalbum.com/saydamWebservice/giveorder.php", {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: body
              }).then((response) => {
                return response.json();
              }).then((data) => {
                this.setState({
                  open: true,
                  submitMessage: data.responseMessage,
                  submitClicked: false,
                });

                if (data.responseType === 200) {
                  this.setState({
                    isSubmit: true,
                    orderGiven: true,
                    backButtonError: false,

                  });
                }
              });
            }
          }
        }
        else if (this.state.value === 6) { // Baskı
          if (Object.keys(this.state.printingObj).length === 0) {
            this.setState({
              open: true,
              submitMessage: "LÜTFEN EKLE BUTONUNA BASTIĞINIZDAN EMİN OLUNUZ.",
              submitClicked: false,
            })
          } else {
            for (let item in  Object.keys(this.state.printingObj)) {
              let ebat = this.state.printingObj[item].ebatValue;
              let number = this.state.printingObj[item].printingNumber;

              let body = (
                "orderType=" + this.state.value
                + "&orderID=" + (parseInt(orderid, 10) + parseInt(1, 10) + parseInt(item, 10))
                + "&orderName=" + this.state.orderType
                + "&companyName=" + localStorage.getItem("companyName")
                + "&companyMail=" + localStorage.getItem("companyMail")
                + "&ebat=" + ebat
                + "&number=" + number
              );
    
              if (this.state.printingDesc) {
                body += "&description=" + encodeURIComponent(this.state.printingDesc);
              } else {
                body += "&description=''";
              }
        
              fetch("https://saydamalbum.com/saydamWebservice/giveorder.php", {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: body 
              }).then((response) => {
                return response.json();
              }).then((data) => {
                console.log(data);
                this.setState({
                  open: true,
                  submitMessage: data.responseMessage,
                  submitClicked: false,
                });

                if (data.responseType === 200) {
                  this.setState({
                    isSubmit: true,
                    orderGiven: true,
                    backButtonError: false,
                  });
                }
              });
            }
          }

        }
      }
    });
  }

  datePickerChange(param1, date) {
    let fulldate = date.getFullYear() + "-" + parseInt(date.getMonth() + 1, 10) + "-" + date.getDate();

    this.setState({
        datePickerValue: date,
        fulldate: fulldate,
    });
    console.log(fulldate, date);
  }

  // Babam edit

  panoramikAlbumEbatChange(event, index, value) {
    this.setState({
      panoramikAlbumEbat: value,
      panoramikAlbumEbatText: event.target.innerText,
    })
  }

  panoramikAlbumEbatChange2(event, index, value) {
    this.setState({
      panoramikAlbumEbat2: value,
      panoramikAlbumEbat2Text: event.target.innerText,
    })
  }


  panoramikAlbumEbatChange3(event, index, value) {
    this.setState({
      panoramikAlbumEbat3: value,
      panoramikAlbumEbat3Text: event.target.innerText,
    })
  }


  schoolAlbumEbatChange(event, index, value) {
    this.setState({
      schoolAlbumEbatValue: value,
      schoolAlbumEbatRightValue: event.target.innerText,
    })
  }

  schoolFamilyAlbumChange(e) {
    if (e.target.value.length > 0 && e.target.value >= 0 && e.target.value <= 20) {
      this.setState({
        schoolFamilyAlbumError: false,
      })
    } else {
      this.setState({
        schoolFamilyAlbumError: true,
      })
    }

    this.setState({
      schoolFamilyAlbumVal: e.target.value,
      schoolCheckFamilyAlbum: true
    })
  }


  specialAlbumDimension(e) {
    let newValue = this.findDimensions(e.target.value);
    this.setState({
      specialAlbumValue: newValue,
      albumRightEbatValue: newValue,
      coverModelValue: null,
      coverRightModelValue: '',
      coverModelError: true,
      selectedCoverKey: null,
      coverPreviewOpen: false,
      coverPreviewIndex: 0,
    });
  }

  schoolCalendarDimension(e) {
    let newValue = this.findDimensions(e.target.value);
    this.setState({
      schoolCalendarDimensionValue: newValue,
    })
  }

  schoolCalendarDimensionNumber(e) {
    this.setState({
      schoolCalendarDimensionNumber: e.target.value,
    })
  }


  tualAlbumEbatChange(ebatValue, ebatRightValue, key, tualNumberVal) {

    let tualObj = Object.assign({}, this.state.tualObj);
    tualObj[key] = {
      ebatValue: ebatRightValue,
      tualNumber: tualNumberVal,
    };
    this.setState({
      tualObj,
    });

  }


  tualOrderSize(e) {
    if (e.target.value < 20) {

      let tualArray = [];

      for (let i = 0; i < parseInt(e.target.value, 10); i++) {
        tualArray.push(<Tual key={i} data={this.state.tualObj} number={i}
                             onChange1={this.tualAlbumEbatChange.bind(this)}/>);
      }

      this.setState({
        tualArray: tualArray,
      })
    }
  }


  photoBlockEbatChange(ebatRightValue, key, numberVal) {

    let photoBlockObj = Object.assign({}, this.state.photoBlockObj);
    photoBlockObj[key] = {
      ebatValue: ebatRightValue,
      photoBlockNumber: numberVal,
    };
    this.setState({
      photoBlockObj,
    });

  }

  photoBlockOrderSize(e) {
    if (e.target.value < 20) {

      let photoBlockArray = [];

      for (let i = 0; i < parseInt(e.target.value, 10); i++) {
        photoBlockArray.push(<PhotoBlock key={i} number={i}
                                         onChange1={this.photoBlockEbatChange.bind(this)}/>);
      }

      this.setState({
        photoBlockArray: photoBlockArray,
      })
    }
  }


  printingEbatChange(ebatValue, ebatRightValue, key, numberVal) {

    let printingObj = Object.assign({}, this.state.printingObj);
    printingObj[key] = {
      ebatValue: ebatRightValue,
      printingNumber: numberVal,
    };
    this.setState({
      printingObj,
    });

  }


  printingOrderSize(e) {
    if (e.target.value < 20) {

      let printingArray = [];

      for (let i = 0; i < parseInt(e.target.value, 10); i++) {
        printingArray.push(<Printing key={i} data={this.state.printingObj} number={i}
                                     onChange1={this.printingEbatChange.bind(this)}/>);
      }

      this.setState({
        printingArray: printingArray,
      })
    }
  }

  backOrder() {
    if (this.state.value === 2) {
      fetch("https://saydamalbum.com/saydamWebservice/orderdelete.php", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: "orderType=" + this.state.value
        + "&orderID=" + (parseInt(this.state.order_id, 10) + parseInt(1, 10))
      }).then((response) => {
        return response.json();
      }).then((data) => {
        this.setState({
          submitMessage: data.responseMessage,
          open: true,
        });

        if (data.responseType === 200) {
          setTimeout(() => {
            this.setState({
              isSubmit: false,
              submitClicked: false,
              orderGiven: false,
              backButtonError: true,
            });
          }, 1500);
        }
      });
    } else if (this.state.value === 3) {
      fetch("https://saydamalbum.com/saydamWebservice/orderdelete.php", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: "orderType=" + this.state.value
        + "&orderID=" + (parseInt(this.state.order_id, 10) + parseInt(1, 10))
      }).then((response) => {
        return response.json();
      }).then((data) => {

        this.setState({
          submitMessage: data.responseMessage,
          open: true,
        });

        if (data.responseType === 200) {
          setTimeout(() => {
            this.setState({
              isSubmit: false,
              submitClicked: false,
              orderGiven: false,
              backButtonError: true,
            });
          }, 1500);
        }
      });
    } else if (this.state.value === 4) { // Tual
      for (let i = this.state.tualArray.length - 1; i >= 0; i--) {
        fetch("https://saydamalbum.com/saydamWebservice/orderdelete.php", {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: "orderType=" + this.state.value
          + "&orderID=" + (parseInt(this.state.order_id, 10) + parseInt(this.state.tualArray.length, 10) - parseInt(i, 10))
        }).then((response) => {
          return response.json();
        }).then((data) => {

          this.setState({
            submitMessage: data.responseMessage,
            open: true,
          });

          if (data.responseType === 200) {

            setTimeout(() => {
              this.setState({
                isSubmit: false,
                submitClicked: false,
                orderGiven: false,
                backButtonError: true,
              });
            }, 1500);
          }
        });
      }
    } else if (this.state.value === 5) {
      for (let i = this.state.photoBlockArray.length - 1; i >= 0; i--) {
        fetch("https://saydamalbum.com/saydamWebservice/orderdelete.php", {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: "orderType=" + this.state.value
          + "&orderID=" + (parseInt(this.state.order_id, 10) + parseInt(this.state.photoBlockArray.length, 10) - parseInt(i, 10))
        }).then((response) => {
          return response.json();
        }).then((data) => {

          this.setState({
            submitMessage: data.responseMessage,
            open: true,
          });

          if (data.responseType === 200) {
            setTimeout(() => {
              this.setState({
                isSubmit: false,
                submitClicked: false,
                orderGiven: false,
                backButtonError: true,
              });
            }, 1500);
          }
        });
      }
    } else if (this.state.value === 6) {
      for (let i = this.state.printingArray.length - 1; i >= 0; i--) {

        fetch("https://saydamalbum.com/saydamWebservice/orderdelete.php", {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: "orderType=" + this.state.value
          + "&orderID=" + (parseInt(this.state.order_id, 10) + parseInt(this.state.printingArray.length, 10) - parseInt(i, 10))
        }).then((response) => {
          return response.json();
        }).then((data) => {

          this.setState({
            submitMessage: data.responseMessage,
            open: true,
          });

          if (data.responseType === 200) {
            setTimeout(() => {
              this.setState({
                isSubmit: false,
                submitClicked: false,
                orderGiven: false,
                backButtonError: true,
              });
            }, 1500);
          }
        });
      }
    }
  }

  findDimensions(e) {
    let x = e.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})/);
    e = !x[2] ? x[1] : '' + x[1] + 'x' + x[2] + (x[3] ? '' + x[3] : '');

    return e;
  }

  render() {
    let pageNumberErrorMessage = "";
    if (this.state.pageNumberError) {
      pageNumberErrorMessage = this.state.checkPageNumber ? "Lütfen 0 ile 25 arası sayfa sayısı giriniz" : "";
    }

    let familyAlbumErrorMessage = "";
    if (this.state.familyAlbumError) {
      familyAlbumErrorMessage = this.state.checkFamilyAlbum ? "Lütfen 0 ile 25 arası sayfa sayısı giriniz" : "";
    }

    let rndNumber = 0;
    if (this.state.isSubmit) {
      rndNumber = Math.floor(Math.random() * 1000);
    }

    let schoolFamilyAlbumErrorMessage = "";
    if (this.state.schoolFamilyAlbumError) {
      schoolFamilyAlbumErrorMessage = this.state.schoolCheckFamilyAlbum ? "Lütfen 0 ile 20 arası sayfa sayısı giriniz" : "";
    }

    let tual = this.state.tualObj;
    let newTual = [];
    for (let prop in tual) {
      newTual.push(tual[prop]);
    }

    const selectedEbatForCovers = this.getSelectedEbatForCovers();
    const availableAlbums = selectedEbatForCovers
      ? this.getAvailableAlbums(selectedEbatForCovers)
      : [];
    const showCoverSelection = this.shouldShowCoverSelection();

    return (
      <div>
        <Header/>

        <main className="order-page">
          <div className="container">
            {localStorage.getItem("companyMail") ? (
              <form className="order-page-container">
                <div className="order-left-side">
                  <h3> Sipariş Girdileri </h3>

                  <div
                    ref={this.contentScrollRef}
                    className={"order-left-side-content " + (this.state.submitClicked ? "load" : "")}>
                    {this.state.submitClicked ? (
                      <div className="submit-loader">
                        <img src={loader} alt="Loader"/>
                      </div>
                    ) : (
                      <span hidden> </span>
                    )}

                    {this.state.isSubmit ? (
                      <div className="submitted-form">
                        <h4> Sipariş başarılı bir şekilde verildi. </h4>
                        <h2> Sipariş Numarası:
                          #{this.state.value === 2 ? (
                            parseInt(this.state.order_id, 10) + parseInt(1, 10)
                          ) : (
                            <span hidden> </span>
                          )}

                          {this.state.value === 3 ? (
                            parseInt(this.state.order_id, 10) + parseInt(1, 10)
                          ) : (
                            <span hidden> </span>
                          )}

                          {this.state.value === 4 ? (
                            parseInt(this.state.order_id, 10) + parseInt(this.state.tualArray.length, 10)
                          ) : (
                            <span hidden> </span>
                          )}

                          {this.state.value === 5 ? (
                            parseInt(this.state.order_id, 10) + parseInt(this.state.photoBlockArray.length, 10)
                          ) : (
                            <span hidden> </span>
                          )}

                          {this.state.value === 6 ? (
                            parseInt(this.state.order_id, 10) + parseInt(this.state.printingArray.length, 10)
                          ) : (
                            <span hidden> </span>
                          )}
                        </h2>

                        <div className="we-transfer">
                          <p className="info">
                            Lütfen sipariş numarasını, göndereceğiniz <b> dosyanın ismi</b> olarak ayarlayıp daha sonrasında wetransferden <b>saydamalbum@gmail.com'a</b> yükleyip gönderiniz.
                          </p>

                          <a href="//wetransfer.com" target="_blank"
                             rel="noopener noreferrer">
                            <RaisedButton
                              label="We Transfer'e Git"
                              backgroundColor="#2c3e50"
                              labelColor="#fff"
                              type="button"
                            />
                          </a>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <p className="info">
                          Lütfen, aşağıdan ilgili kutucukları doldurup sağ taraftan
                          önizlemesini
                          gerçekleştiriniz.
                          Daha sonra size bir çıktı üretip, wetransfer'e yönlendireceğiz.
                          Açıklama
                          kısmında ürettiğimiz çıktıyı
                          kopyalayıp, wetransfere yapıştırıp dosyalarınızı gönderebilirsiniz.
                        </p>

                        {this.state.formStep === 1 ? (
                          <div className="form-step form-step-1">
                            <SelectField
                              floatingLabelText="Sipariş Türü"
                              value={this.state.value}
                              floatingLabelStyle={styles.successColor}
                              onChange={this.handleChange.bind(this)}
                            >
                              <MenuItem value={1} primaryText="Sipariş Türünüzü Seçiniz"/>
                              <MenuItem value={2} primaryText="Panoramik Albüm"/>
                              <MenuItem value={3} primaryText="Okul Albüm"/>
                              <MenuItem value={4} primaryText="Tual"/>
                              <MenuItem value={5} primaryText="Fotoblok"/>
                              <MenuItem value={6} primaryText="Baskı"/>
                            </SelectField>

                            {this.renderContentContinueButton()}
                          </div>
                        ) : (
                          <div className={`form-step form-step-${this.state.formStep}`}>
                            <div className="form-group form-step-actions">
                              <RaisedButton
                                label={this.state.value === 2 && this.state.formStep === 3 ? 'Kapak Seçimine Dön' : 'Sipariş Türüne Dön'}
                                backgroundColor="#2c3e50"
                                labelColor="#fff"
                                type="button"
                                onClick={this.handleFormBack.bind(this)}
                              />
                            </div>

                            {!(this.state.value === 2 && this.state.formStep === 3) && (
                              <div className="selected-order-type">
                                <strong>Sipariş Türü:</strong> {this.state.orderType}
                              </div>
                            )}

                        {
                          (this.state.value === 2 && this.state.formStep === 2) ? (
                            <div className="album-content contents panoramic-selection-step">
                              <div className="form-group">
                                <label className="field-label">Albüm Ebatı</label>
                                <div className="ebat-chips">
                                  {ALL_EBADS.map((ebat) => (
                                    <button
                                      key={ebat}
                                      type="button"
                                      className={`ebat-chip ${this.state.albumEbatValue === ebat ? 'selected' : ''}`}
                                      onClick={() => this.albumEbatChipClick(ebat)}
                                    >
                                      {ebat}
                                    </button>
                                  ))}
                                  <button
                                    type="button"
                                    className={`ebat-chip ${this.state.albumEbatValue === 'custom' ? 'selected' : ''}`}
                                    onClick={() => this.albumEbatChipClick('custom')}
                                  >
                                    Özel Ebat
                                  </button>
                                </div>

                                {this.state.albumEbatValue === 'custom' && (
                                  <TextField
                                    type="text"
                                    hintText="Sadece rakamları yazın"
                                    floatingLabelText="Özel Ebatı Gir"
                                    onChange={this.specialAlbumDimension.bind(this)}
                                    value={this.state.specialAlbumValue || ''}
                                    floatingLabelStyle={styles.successColor}
                                  />
                                )}
                              </div>

                              {showCoverSelection && (
                                <div className="form-group">
                                  <label className="field-label">
                                    Kapak Modeli
                                    {availableAlbums.length > 0 && (
                                      <span className="cover-model-count">
                                        ({availableAlbums.length} model)
                                      </span>
                                    )}
                                  </label>
                                  <p className="cover-model-help">
                                    {this.state.isCustomEbat
                                      ? 'Özel ebatınız için uygun kapak modelleri listelenmektedir.'
                                      : `${this.state.albumRightEbatValue} ebatı için uygun kapak modelleri listelenmektedir.`}
                                    {' '}Kapak fotoğrafına tıklayarak büyük önizleme açabilirsiniz.
                                  </p>

                                  {availableAlbums.length > 0 ? (
                                  <div className="cover-model-grid">
                                    {availableAlbums.map(([key, album], index) => (
                                      <div
                                        key={key}
                                        className={`cover-model-item ${this.state.selectedCoverKey === key ? 'selected' : ''}`}
                                      >
                                        {this.state.selectedCoverKey === key && (
                                          <span className="cover-model-selected-badge">Seçildi</span>
                                        )}

                                        <button
                                          type="button"
                                          className="cover-model-preview-trigger"
                                          onClick={() => this.openCoverPreview(index)}
                                          aria-label={`${album.name} önizle`}
                                        >
                                          <img src={album.image} alt={album.name}/>
                                          <span className="cover-model-preview-hint">
                                            <i className="material-icons">zoom_in</i>
                                            Önizle
                                          </span>
                                        </button>

                                        <span className="cover-model-name">{album.name}</span>

                                        <div className="cover-model-select-btn">
                                          <RaisedButton
                                            label={this.state.selectedCoverKey === key ? 'Seçildi' : 'Bu Modeli Seç'}
                                            backgroundColor={this.state.selectedCoverKey === key ? '#27ae60' : '#2c3e50'}
                                            labelColor="#fff"
                                            type="button"
                                            onClick={() => this.coverAlbumSelect(key, album.name)}
                                          />
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                  ) : (
                                    <p className="cover-model-empty">
                                      Bu ebat için uygun kapak modeli bulunamadı.
                                    </p>
                                  )}
                                </div>
                              )}

                            </div>
                          ) : ("")
                        }

                        {
                          (this.state.value === 2 && this.state.formStep === 3) ? (
                            <div className="album-content contents panoramic-details-step">
                              {this.renderPanoramicSelectionSummary()}

                              {!(this.state.albumEbatValue === '25x40') ? (
                                <div className="form-group" id="fourInput">
                                  <TextField
                                    type="number"
                                    hintText=""
                                    floatingLabelText={(this.state.albumRightEbatValue || 'Albüm') + " Albüm Adeti"}
                                    floatingLabelStyle={styles.successColor}
                                    onChange={(e) => this.setState({panoramikLength: e.target.value})}
                                  />

                                  <TextField
                                    type="number"
                                    hintText="0-10 Arası rakam ile belirtiniz"
                                    floatingLabelText={
                                      "Aile Albümü Adet"
                                      + ((this.state.albumEbatValue === '30x50') ? " - 15x25" : "")
                                      + ((this.state.albumEbatValue === '30x60') ? " - 15x30" : "")
                                      + ((this.state.albumEbatValue === '25x50') ? " - 25x50" : "")
                                    }
                                    errorText={familyAlbumErrorMessage}
                                    errorStyle={this.state.familyAlbumError ? styles.errorColor : styles.successColor}
                                    floatingLabelStyle={this.state.familyAlbumError ? styles.errorColor : styles.successColor}
                                    onChange={this.familyAlbumChange.bind(this)}
                                  />

                                  {((this.state.albumEbatValue === '30x70') && (this.state.familyAlbumVal > 0)) ? (
                                    <div>
                                      <SelectField
                                        id="panoramik-album-ebat"
                                        floatingLabelText="30x70 Aile için Ebat Seçiniz"
                                        value={this.state.panoramikAlbumEbat}
                                        onChange={this.panoramikAlbumEbatChange.bind(this)}
                                      >
                                        <MenuItem value={1}
                                                  primaryText="15x35"/>
                                        <MenuItem value={2}
                                                  primaryText="20x46"/>
                                      </SelectField>
                                    </div>
                                  ) : (
                                    <span></span>
                                  )}

                                  {((this.state.albumEbatValue === '30x80') && (this.state.familyAlbumVal > 0)) ? (
                                    <div>
                                      <SelectField
                                        id="panoramik-album-ebat2"
                                        floatingLabelText="30x80 Aile için Ebat Seçiniz"
                                        value={this.state.panoramikAlbumEbat2}
                                        onChange={this.panoramikAlbumEbatChange2.bind(this)}
                                      >
                                        <MenuItem value={1}
                                                  primaryText="15x40"/>
                                        <MenuItem value={2}
                                                  primaryText="20x50"/>
                                      </SelectField>
                                    </div>
                                  ) : (
                                    <span></span>
                                  )}
                                </div>
                              ) : (
                                <span></span>
                              )}

                              <div className="form-group">
                                <SelectField
                                  id="album-type"
                                  floatingLabelText="Albüm Türü"
                                  value={this.state.albumValue}
                                  floatingLabelStyle={styles.successColor}
                                  onChange={this.albumValueChange.bind(this)}
                                >
                                  <MenuItem value={1} primaryText="Mat"/>
                                  <MenuItem value={4} primaryText="Parlak"/>
                                </SelectField>
                              </div>

                              <div className="form-group">
                                <TextField
                                  type="number"
                                  floatingLabelText="Sayfa Sayısı"
                                  errorText={pageNumberErrorMessage}
                                  errorStyle={this.state.pageNumberError ? styles.errorColor : styles.successColor}
                                  floatingLabelStyle={this.state.pageNumberError ? styles.errorColor : styles.successColor}
                                  onChange={this.pageNumberChange.bind(this)}
                                />
                              </div>

                              {this.state.selectedCoverKey && (
                                <div className="form-group">
                                  <TextField
                                    type="text"
                                    hintText="Sadece rakamları yazın"
                                    floatingLabelText="Gelin & Damat & Bebek İsim"
                                    floatingLabelStyle={styles.successColor}
                                    value={this.state.brideName}
                                    onChange={(e) => this.setState({ brideName: e.target.value })}
                                  />

                                  <DatePicker
                                    hintText="Gelin & Damat & Bebek Tarih"
                                    firstDayOfWeek={0}
                                    locale='tr-TR'
                                    okLabel="Tamam"
                                    cancelLabel="İptal"
                                    autoOk="true"
                                    onChange={this.datePickerChange.bind(this)}
                                    DateTimeFormat={ Intl.DateTimeFormat}
                                  />
                                </div>
                              )}

                              <div className="form-group albumRanking">
                                <label htmlFor="albumRanking">
                                  Albüm Sıralama
                                </label>
                                <RadioButtonGroup name="albumRanking" defaultSelected="1" onChange={this.albumRankingChange.bind(this)}>
                                  <RadioButton
                                    value="1"
                                    label="Sıralı"
                                  />
                                  <RadioButton
                                    value="0"
                                    label="Sırasız"
                                  />
                                </RadioButtonGroup>
                              </div>

                              <div className="form-group-row baski-tual-row">
                                <div className="form-group">
                                  <TextField
                                    type="text"
                                    hintText="Sadece rakamları yazın"
                                    floatingLabelText="Baskı(Poster - Ebat)"
                                    floatingLabelStyle={styles.successColor}
                                    value={this.state.albumGiftPhotoValue}
                                    onChange={this.giftPhotoChange.bind(this)}
                                  />
                                </div>

                                <div className="form-group">
                                  <TextField
                                    type="text"
                                    hintText="Sadece rakamları yazın"
                                    floatingLabelText="Tual(Ebat)"
                                    floatingLabelStyle={styles.successColor}
                                    onChange={this.giftTualChange.bind(this)}
                                    value={this.state.albumGiftTualValue}
                                  />
                                </div>
                              </div>


                              <div className="form-group description">
                                <label htmlFor="album-description">
                                  Açıklama
                                </label>

                                <textarea name="" id="" cols="30" rows="10"
                                          onChange={this.descChange.bind(this)}>
                                                    </textarea>
                              </div>
                            </div>
                          ) : ("")
                        }

                        {
                          (this.state.value === 3 && this.state.formStep === 2) ? (
                            <div className="school-content contents">
                              <div className="form-group">
                                <SelectField
                                  id="school-album-ebat"
                                  floatingLabelText="Albüm Ebatı"
                                  value={this.state.schoolAlbumEbatValue}
                                  floatingLabelStyle={styles.successColor}
                                  onChange={this.schoolAlbumEbatChange.bind(this)}
                                >
                                  <MenuItem value={1} primaryText="25x40"/>
                                  <MenuItem value={2} primaryText="30x40"/>
                                  <MenuItem value={3} primaryText="30x45"/>
                                  <MenuItem value={4} primaryText="20x50"/>
                                  <MenuItem value={5} primaryText="20x60"/>
                                  <MenuItem value={6} primaryText="25x50"/>
                                  <MenuItem value={7} primaryText="25x60"/>
                                  <MenuItem value={8}
                                            primaryText="30x50 - (Kelebek Albüm)"/>
                                  <MenuItem value={9}
                                            primaryText="25x40 - (Akordiyon İkili)"/>
                                  <MenuItem value={10}
                                            primaryText="25x60 - (Akordiyon Üçlü)"/>
                                  <MenuItem value={11}
                                            primaryText="25x40 - (Açmalı Kapak)"/>
                                  <MenuItem value={12} primaryText="Takvim"

                                  />
                                </SelectField>
                              </div>

                              {(this.state.schoolAlbumEbatValue === 11) ? (
                                <div>
                                  <div className="form-group">
                                    <TextField
                                      type="text"
                                      hintText="Sadece rakamları giriniz"
                                      floatingLabelText="Takvim Ebatı"
                                      floatingLabelStyle={styles.successColor}
                                      onChange={this.schoolCalendarDimension.bind(this)}
                                      value={this.state.schoolCalendarDimensionValue}
                                    />
                                  </div>

                                  <div className="form-group">
                                    <TextField
                                      type="number"
                                      hintText="Takvim Sayısı"
                                      floatingLabelStyle={styles.successColor}
                                      floatingLabelText="Takvim Sayısı"
                                      onChange={this.schoolCalendarDimensionNumber.bind(this)}
                                    />
                                  </div>
                                </div>
                              ) : (
                                !(this.state.schoolAlbumEbatValue === 8 || this.state.schoolAlbumEbatValue === 9 || this.state.schoolAlbumEbatValue === 10) ? (
                                  <div>
                                    <div className="form-group">
                                      <TextField
                                        type="number"
                                        hintText="0-20 Arası rakam ile belirtiniz"
                                        floatingLabelText="Sayfa Sayısı"
                                        errorText={schoolFamilyAlbumErrorMessage}
                                        errorStyle={this.state.schoolFamilyAlbumError ? styles.errorColor : styles.successColor}
                                        floatingLabelStyle={this.state.schoolFamilyAlbumError ? styles.errorColor : styles.successColor}
                                        onChange={this.schoolFamilyAlbumChange.bind(this)}
                                      />
                                    </div>

                                    <div className="form-group">
                                      <TextField
                                        type="number"
                                        hintText="Öğrenci Adetini Giriniz"
                                        floatingLabelText="Öğrenci Adet"
                                        floatingLabelStyle={styles.successColor}
                                        onChange={(e) => {
                                          this.setState({schoolStudentNumber: e.target.value})
                                        }}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <div className="form-group">
                                    <TextField
                                      type="number"
                                      hintText="Öğrenci Adetini Giriniz"
                                      floatingLabelText="Öğrenci Adet"
                                      floatingLabelStyle={styles.successColor}
                                      onChange={(e) => {
                                        this.setState({schoolStudentNumber2: e.target.value})
                                      }}
                                    />
                                  </div>
                                )
                              )}

                              <div className="form-group school-description description">
                                <label htmlFor="school-description">
                                  Açıklama
                                </label>

                                <textarea
                                  name=""
                                  id="school-description"
                                  cols="30"
                                  rows="10"
                                  onChange={(e) => this.setState({schoolDescription: e.target.value})}
                                > </textarea>
                              </div>
                            </div>
                          ) : ("")
                        }

                        {
                          (this.state.value === 4 && this.state.formStep === 2) ? (
                            <div className="tual-content contents">
                              <div className="form-group order-number">
                                <TextField
                                  type="number"
                                  hintText="Sipariş Sayısı (max-20)"
                                  floatingLabelStyle={styles.successColor}
                                  floatingLabelText="Sipariş Sayısı"
                                  onChange={this.tualOrderSize.bind(this)}
                                />
                              </div>

                              {this.state.tualArray}

                              <div className="form-group description">
                                <label htmlFor="tual-description">
                                  Açıklama
                                </label>

                                <textarea
                                  name=""
                                  id="tual-description"
                                  cols="30"
                                  rows="10"
                                  onChange={(e) => this.setState({tualDesc: e.target.value})}
                                > </textarea>
                              </div>
                            </div>
                          ) : ("")
                        }

                        {
                          (this.state.value === 5 && this.state.formStep === 2) ? (
                            <div className="photoPrinting-content contents">

                              <div className="form-group order-number">
                                <TextField
                                  type="number"
                                  hintText="Sipariş Sayısı (max-20)"
                                  floatingLabelStyle={styles.successColor}
                                  floatingLabelText="Sipariş Sayısı"
                                  onChange={this.photoBlockOrderSize.bind(this)}
                                />
                              </div>

                              {this.state.photoBlockArray}

                              <div className="form-group description">
                                <label htmlFor="photoPrinting-description">
                                  Açıklama
                                </label>

                                <textarea
                                  name=""
                                  id="photoPrinting-description"
                                  cols="30"
                                  rows="10"
                                  onChange={(e) => this.setState({photoBlockDesc: e.target.value})}
                                > </textarea>
                              </div>
                            </div>
                          ) : ("")
                        }

                        {
                          (this.state.value === 6 && this.state.formStep === 2) ? (
                            <div className="printing-content contents">
                              <div className="form-group order-number">
                                <TextField
                                  type="number"
                                  hintText="Sipariş Sayısı (max-20)"
                                  floatingLabelStyle={styles.successColor}
                                  floatingLabelText="Sipariş Sayısı"
                                  onChange={this.printingOrderSize.bind(this)}
                                />
                              </div>


                              {this.state.printingArray}

                              <div className="form-group description">
                                <label htmlFor="printing-description">
                                  Açıklama
                                </label>

                                <textarea name=""
                                          id="printing-description"
                                          cols="30"
                                          rows="10"
                                          onChange={(e) => this.setState({printingDesc: e.target.value}) }
                                > </textarea>
                              </div>
                            </div>
                          ) : ("")
                        }

                            {this.renderContentContinueButton()}
                          </div>
                        )}
                      </div>
                    )}


                  </div>
                </div>


                {/*Right*/}

                <div className="order-right-side">
                  <h3> Sipariş Önizleme </h3>

                  <div className="order-right-side-content">
                    {(this.state.value === 2) ? (
                      <ul>
                        <li>
                          <strong> Sipariş Türü: </strong>
                          <span>
                                                {this.state.orderType}
                                            </span>
                        </li>

                        <li>
                          <strong> Albüm Ebatı: </strong>
                          <span>{this.state.albumRightEbatValue}</span>
                        </li>

                        <li>
                          <strong> Panoramik Albüm Sayısı: </strong>
                          <span>{this.state.panoramikLength}</span>
                        </li>

                        <li>
                          <strong> Aile Albümü: </strong>
                          <span>
                                                {this.state.familyAlbumVal}
                                            </span>
                        </li>

                        <li>
                          <strong> Albüm Türü: </strong>
                          <span>
                                                {this.state.albumRightValue}
                                            </span>
                        </li>

                        <li>
                          <strong> Sayfa Sayısı: </strong>
                          <span>
                                                {this.state.pageNumber}
                                            </span>
                        </li>


                        <li>
                          <strong> Kapak Modeli: </strong>
                          <span>{this.state.coverRightModelValue}</span>
                        </li>

                        <li>
                          <strong> Gelin & Damat & Bebek İsmi: </strong>
                          <span>{this.state.brideName}</span>
                        </li>

                        <li>
                          <strong> Gelin & Damat & Bebek Tarihi: </strong>
                          <span>{this.state.fulldate}</span>
                        </li>

                        <li>
                          <strong> Albüm Sıralama: </strong>
                          <span>
                                                {this.state.albumRankingValue}
                                            </span>
                        </li>


                        <li>
                          <strong> Baskı: </strong>
                          <span>
                                                {this.state.albumGiftPhotoValue}
                                            </span>
                        </li>

                        <li>
                          <strong> Tual: </strong>
                          <span>
                                                {this.state.albumGiftTualValue}
                                            </span>
                        </li>

                        <li>
                          <strong> Açıklama: </strong>
                          <span>
                                                {this.state.albumDescription}
                                            </span>
                        </li>
                      </ul>
                    ) : (
                      <span hidden> </span>
                    )}

                    {(this.state.value === 3) ? (
                      (this.state.schoolAlbumEbatValue === 11) ? (
                        <ul>
                          <li>
                            <strong> Sipariş Türü: </strong>
                            <span> {this.state.orderType} </span>
                          </li>

                          <li>
                            <strong> Albüm: </strong>
                            <span>{this.state.schoolAlbumEbatRightValue}</span>
                          </li>

                          <li>
                            <strong> Takvim Ebatı: </strong>
                            <span> {this.state.schoolCalendarDimensionValue} </span>
                          </li>

                          <li>
                            <strong> Takvim Sayısı: </strong>
                            <span> {this.state.schoolCalendarDimensionNumber} </span>
                          </li>

                          <li>
                            <strong> Açıklama: </strong>
                            <span> {this.state.schoolDescription} </span>
                          </li>
                        </ul>
                      ) : (
                        !(this.state.schoolAlbumEbatValue === 8 || this.state.schoolAlbumEbatValue === 9 || this.state.schoolAlbumEbatValue === 10) ? (
                          <ul>
                            <li>
                              <strong> Sipariş Türü: </strong>
                              <span> {this.state.orderType} </span>
                            </li>

                            <li>
                              <strong> Albüm Ebatı: </strong>
                              <span>{this.state.schoolAlbumEbatRightValue}</span>
                            </li>

                            <li>
                              <strong> Sayfa Sayısı: </strong>
                              <span> {this.state.schoolFamilyAlbumVal} </span>
                            </li>

                            <li>
                              <strong> Öğrenci Adeti: </strong>
                              <span>{this.state.schoolStudentNumber}</span>
                            </li>

                            <li>
                              <strong> Açıklama: </strong>
                              <span> {this.state.schoolDescription} </span>
                            </li>
                          </ul>
                        ) : (
                          <ul>
                            <li>
                              <strong> Sipariş Türü: </strong>
                              <span> {this.state.orderType} </span>
                            </li>

                            <li>
                              <strong> Albüm Ebatı: </strong>
                              <span>{this.state.schoolAlbumEbatRightValue}</span>
                            </li>

                            <li>
                              <strong> Öğrenci Adeti: </strong>
                              <span>{this.state.schoolStudentNumber2}</span>
                            </li>

                            <li>
                              <strong> Açıklama: </strong>
                              <span> {this.state.schoolDescription} </span>
                            </li>
                          </ul>
                        ))
                    ) : (
                      <span hidden> </span>
                    )}

                    {(this.state.value === 4) ? (
                      <ul>
                        <li>
                          <strong> Sipariş Türü: </strong>
                          <span> {this.state.orderType} </span>
                        </li>

                        { Object.keys(this.state.tualObj).map((item, i) => (
                          <li key={i}>
                            <strong>{"(" + (i + 1) + ")" } Tual Ebatı </strong>
                            <span>{this.state.tualObj[item].ebatValue + " - " + this.state.tualObj[item].tualNumber + " Adet"}</span>
                          </li>
                        ))}

                        <li>
                          <strong> Açıklama: </strong>
                          <span> {this.state.tualDesc} </span>
                        </li>
                      </ul>
                    ) : (
                      <span hidden> </span>
                    )}

                    {(this.state.value === 5) ? (
                      <ul>
                        <li>
                          <strong> Sipariş Türü: </strong>
                          <span> {this.state.orderType} </span>
                        </li>

                        { Object.keys(this.state.photoBlockObj).map((item, i) => (
                          <li key={i}>
                            <strong>{"(" + (i + 1) + ")" } Fotoblok Ebatı </strong>
                            <span>{this.state.photoBlockObj[item].ebatValue + " - " + this.state.photoBlockObj[item].photoBlockNumber + " Adet"}</span>
                          </li>
                        ))}

                        <li>
                          <strong> Açıklama: </strong>
                          <span> {this.state.photoBlockDesc} </span>
                        </li>

                      </ul>
                    ) : (
                      <span hidden> </span>
                    )}

                    {(this.state.value === 6) ? (
                      <ul>
                        <li>
                          <strong> Sipariş Türü: </strong>
                          <span> {this.state.orderType} </span>
                        </li>

                        { Object.keys(this.state.printingObj).map((item, i) => (
                          <li key={i}>
                            <strong>{"(" + (i + 1) + ")" } Baskı Ebatı </strong>
                            <span>{this.state.printingObj[item].ebatValue + " - " + this.state.printingObj[item].printingNumber + " Adet"}</span>
                          </li>
                        ))}

                        <li>
                          <strong> Açıklama: </strong>
                          <span> {this.state.printingDesc} </span>
                        </li>

                      </ul>
                    ) : (
                      <span hidden> </span>
                    )}
                  </div>

                  <div className="buttons">
                    <RaisedButton
                      label="Geri"
                      backgroundColor="#2c3e50"
                      labelColor="#fff"
                      type="button"
                      onClick={this.handleSidebarBack.bind(this)}
                      disabled={
                        this.state.isSubmit
                          ? this.state.backButtonError
                          : !this.canGoBackInForm()
                      }
                    />

                    <RaisedButton
                      label={this.isLastFormStep() ? 'Siparişi Tamamla' : 'Devam'}
                      backgroundColor="#2c3e50"
                      labelColor="#fff"
                      onClick={this.handlePrimaryAction.bind(this)}
                      type="button"
                      disabled={
                        this.state.orderGiven
                        || this.state.isSubmit
                        || (this.isLastFormStep()
                          ? this.state.value === 1
                          : !this.canProceedToNextStep())
                      }
                    />
                  </div>

                </div>
              </form>
            ) : (
              <div className="warning-alert">
                <i className="material-icons">warning</i>
                Lütfen üye girişi yapınız..
              </div>
            )}
          </div>
        </main>

        <Snackbar
          open={this.state.open}
          message={this.state.submitMessage}
          autoHideDuration={2000}
          onRequestClose={this.snackbarClose}
        />

        {this.state.coverPreviewOpen && availableAlbums.length > 0 && (
          <Lightbox
            mainSrc={availableAlbums[this.state.coverPreviewIndex][1].image}
            imageTitle={availableAlbums[this.state.coverPreviewIndex][1].name}
            nextSrc={availableAlbums[(this.state.coverPreviewIndex + 1) % availableAlbums.length][1].image}
            prevSrc={availableAlbums[(this.state.coverPreviewIndex + availableAlbums.length - 1) % availableAlbums.length][1].image}
            onCloseRequest={this.closeCoverPreview.bind(this)}
            onMoveNextRequest={() => this.moveCoverPreview(1)}
            onMovePrevRequest={() => this.moveCoverPreview(-1)}
            imageCaption={(
              <div className="cover-lightbox-caption">
                <p>{availableAlbums[this.state.coverPreviewIndex][1].name}</p>
                <RaisedButton
                  label={
                    this.state.selectedCoverKey === availableAlbums[this.state.coverPreviewIndex][0]
                      ? 'Seçildi'
                      : 'Bu Modeli Seç'
                  }
                  backgroundColor={
                    this.state.selectedCoverKey === availableAlbums[this.state.coverPreviewIndex][0]
                      ? '#27ae60'
                      : '#2c3e50'
                  }
                  labelColor="#fff"
                  type="button"
                  onClick={this.selectCoverFromPreview.bind(this)}
                />
              </div>
            )}
          />
        )}

        <Footer />
      </div>
    );
  }
}


export default Order;

